import * as React from 'react';
import * as styles from './FeedAdmin.css';
import { Store } from './stores';
import { inject, observer } from 'mobx-react';
import { LocalizationService } from '../../services/LocalizationService';
import { IAPivot } from '../pivot/Pivot';
import FeedService from '../../services/FeedService';
import { FeedOverview } from './feedOverview/FeedOverview';

export interface IProps {
  store?: Store;
}

export interface IState {
}

@inject('store')
@observer
export class FeedAdmin extends React.Component<IProps, IState> {

  private readonly localizationService: LocalizationService = new LocalizationService();

  constructor(props: IProps) {
    super(props);
    this.state = {
    }
    this.localizationService?.checkLocalizedStrings().then(() => this.forceUpdate());
  }

  public componentDidMount(): void {
    this.getFeeds();
  }

  private getFeeds() {
    this.props.store.isLoadingFeeds = true;
    this.props.store.resetStore();
    FeedService.getFeeds(this.props.store.environment, this.props.store.tenant, this.props.store.token, this.props.store.selectedApplication, "")
      .then(feeds => {
        this.props.store.feeds = feeds;
        this.forceUpdate();
      })
      .finally(() =>  {
        FeedService.getFeedStructure(this.props.store.environment, this.props.store.tenant, this.props.store.selectedApplication)
          .then(structure => {
            const structuredIds = this.props.store.flattenStructure(JSON.parse(JSON.stringify(structure))).map(feed => feed.id);
            const unstructuredIds = this.props.store.feeds.filter(feed => !structuredIds.find(structuredId => structuredId === feed.id));
            this.props.store.unstructuredFeeds = unstructuredIds.map(feed => {
                return {
                  id: feed.id,
                  highlighted: false,
                  title: feed.title,
                  children: []
                }
              }
            );
            this.props.store.unstructuredFeedsBeforeChanges = JSON.parse(JSON.stringify(this.props.store.unstructuredFeeds));
            this.props.store.structuredFeeds = structure;
            this.props.store.structuredFeedsBeforeChanges = structure;
            if (this.props.store.structuredFeeds.length === 0) {
              this.props.store.isStartingFromScratch = true;
            }
          })
          .catch(error => {
            if (error === 404) {
              // structure not set up yet - add everything to a flat structure
              this.props.store.unstructuredFeeds = this.props.store.feeds.map(feed => {
                return {
                  id: feed.id,
                  highlighted: false,
                  title: feed.title,
                  children: []
                }
              });
              this.props.store.unstructuredFeedsBeforeChanges = JSON.parse(JSON.stringify(this.props.store.unstructuredFeeds));
              this.props.store.isStartingFromScratch = true;
            }
          })
          .finally(() => this.props.store.isLoadingFeeds = false);
      });
  }

  public render(): JSX.Element {
    return <div className={styles.FeedAdmin_Wrapper}>
      <IAPivot
        highlightColor={this.props.store.highlightColor}
        items={[
          {
            key: "messages",
            text: this.localizationService.strings.FeedAdmin_Messages
          },
          {
            key: "events",
            text: this.localizationService.strings.FeedAdmin_Events
          }
        ]}
        selectedKey={this.props.store.selectedApplication}
        select={(key: "messages" | "events") => {
          if (key !== this.props.store.selectedApplication) {
            this.props.store.selectedApplication = key;
            this.getFeeds();
          }
        }}
      />
      <FeedOverview
        onFeedUpdatedOrCreated={() => this.getFeeds()}
      />
    </div>;
  }
}